/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  const MOBILE_MQ = "(max-width: 749px)";
  const HIDDEN_CLASS = "js__header__scroll-hidden";
  const MIN_SCROLL = 80;

  let mediaQuery = null;

  function isMobile() {
    return mediaQuery.matches;
  }

  function isScrollLocked() {
    return document.documentElement.hasAttribute("data-scroll-locked");
  }

  function getStickyHeader() {
    return document.querySelector(
      "[data-header-sticky][data-header-hide-on-scroll]",
    );
  }

  function setHidden(hidden) {
    document.body.classList.toggle(HIDDEN_CLASS, Boolean(hidden));
  }

  function onScroll(event) {
    if (!isMobile()) return;
    const header = getStickyHeader();
    if (!header || isScrollLocked()) {
      setHidden(false);
      return;
    }

    const detail = event.detail || {};
    const position = detail.position ?? window.scrollY;
    const isStuck = header.classList.contains("js__header__stuck");

    if (!isStuck || position <= MIN_SCROLL) {
      setHidden(false);
      return;
    }

    if (detail.down) {
      setHidden(true);
    } else if (detail.up) {
      setHidden(false);
    }
  }

  function onMediaChange(event) {
    if (!event.matches) {
      setHidden(false);
    }
  }

  document.addEventListener("theme:scroll", onScroll);
  window.addEventListener("theme:scroll:lock", function () {
    setHidden(false);
  });

  mediaQuery = window.matchMedia(MOBILE_MQ);
  if (typeof mediaQuery.addEventListener === "function") {
    mediaQuery.addEventListener("change", onMediaChange);
  } else if (typeof mediaQuery.addListener === "function") {
    mediaQuery.addListener(onMediaChange);
  }
})();
